module.exports = __webpack_public_path__ + "img/client_qrcode.dadaeafc.png";